// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__WYUxy","spinner":"loader_spinner__xzHdT"};